import { render, staticRenderFns } from "./InvalidInvitationKey.vue?vue&type=template&id=54bc7b13&scoped=true"
import script from "./InvalidInvitationKey.vue?vue&type=script&lang=js"
export * from "./InvalidInvitationKey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bc7b13",
  null
  
)

export default component.exports